module.exports = __webpack_public_path__ + "static/what-434144559b76e163d7904a78da5d8c49.jpg";